// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f2880aa1","982":"c8fe0233"}[chunkId] + ".chunk.js";
};